import { Link } from "react-router-dom";
import { NAV, useSectionNav } from "./Header";
import { Mark } from "./Mark";
import { Reveal } from "./Motion";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "./InstagramSection";

export const Footer = () => {
  const go = useSectionNav();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#0a0b0d]">
      <div className="mx-auto max-w-[1600px] px-6 pt-20 sm:px-10 lg:px-14">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Mark className="h-12 w-auto" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#b4b2ad]">HQ & showrooms for global fashion and accessories brands. Unit 1, Dundrum Business Park, Dublin 14.</p>
          </div>
          <nav className="grid grid-cols-2 gap-3 md:col-span-4">
            {NAV.map((n) => (
              <button key={n.id} data-testid={`footer-nav-${n.id}`} onClick={() => go(n.id)} className="link-u w-fit pb-1 text-left text-sm text-[#d6d3cd] hover:text-white">{n.label}</button>
            ))}
          </nav>
          <div className="flex flex-col gap-3 text-sm md:col-span-3">
            <a href="mailto:sales@julespound.ie" data-testid="footer-email" className="link-u w-fit pb-1 text-[#d6d3cd]">sales@julespound.ie</a>
            <a href="tel:+35312079300" data-testid="footer-phone" className="link-u w-fit pb-1 text-[#d6d3cd]">+353 1 207 9300</a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex w-fit items-center gap-2 text-[#d6d3cd] transition-colors hover:text-[#c8a97e]">
              <Instagram className="h-4 w-4" /> <span className="link-u pb-1">{INSTAGRAM_HANDLE}</span>
            </a>
          </div>
        </div>
        <Reveal y={80} className="mb-16 mt-20 flex justify-center">
          <img data-testid="footer-logo" src="/assets/jh-sun-logo.png" alt="Jaisun House" className="w-full max-w-[220px] sm:max-w-[360px] lg:max-w-[440px]" />
        </Reveal>
        <div className="flex flex-col gap-3 border-t border-white/10 py-8 font-mono text-[11px] uppercase tracking-[0.2em] text-[#b4b2ad] sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} Jaisun House. All rights reserved.</span>
          <span className="flex gap-6">
            <Link to="/terms" data-testid="footer-terms" className="link-u pb-1">Terms</Link>
            <Link to="/privacy" data-testid="footer-privacy" className="link-u pb-1">Privacy</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
